var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertIconNotFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12ZM22.5941 12C22.5941 17.851 17.851 22.5941 12 22.5941C6.14902 22.5941 1.40586 17.851 1.40586 12C1.40586 6.14902 6.14902 1.40586 12 1.40586C17.851 1.40586 22.5941 6.14902 22.5941 12ZM13 13.75V5.5C13 5.08579 12.6642 4.75 12.25 4.75C11.8358 4.75 11.5 5.08579 11.5 5.5V13.75C11.5 14.1642 11.8358 14.5 12.25 14.5C12.6642 14.5 13 14.1642 13 13.75ZM11.125 17.125C11.125 17.7462 11.6288 18.25 12.25 18.25C12.8712 18.25 13.375 17.7462 13.375 17.125C13.375 16.5038 12.8712 16 12.25 16H12.2496C11.6285 16.0002 11.125 16.5039 11.125 17.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIconNotFull);
export default __webpack_public_path__ + "static/media/alert-icon-not-full.7ab0559d4ca70c155ba971f9e2e5623b.svg";
export { ForwardRef as ReactComponent };